module.exports = __webpack_public_path__ + "static/img/2023_9_8_9.8f40041a.8f40041.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_9.8f40041a.png
// module id = HwQ8
// module chunks = 0